/** @jsx jsx */
import { useInterval } from "@cd2/components"
import { useSkeem } from "../providers/SkeemProvider"
import { useHistory } from "react-router-dom"
import { useApi } from "../providers/ApiProvider"

export function AuthorizationHeartbeat({ onAutoLogout }: { onAutoLogout?(): void }) {
  const skeem = useSkeem()
  const api = useApi()
  const history = useHistory()

  useInterval(async () => {
    if (!skeem.currentSession.id) {
      return
    }

    const result = await api.authorizeHeartbeat(skeem.currentSession.sessionId)
    if (!result.authorized) {
      onAutoLogout?.()
      history.push("/logout")
    }
  }, 10 * 1000)

  return null
}
